/** 桌面端 Footer 弹窗位掩码可支持的最大图标下标。 */
const MAX_POPOVER_INDEX = 30

/** Footer 社媒二维码弹窗可见状态的位掩码。 */
export type FooterPopoverVisibleMask = number

/**
 * 获取指定 Footer 社媒图标在位掩码中的标记位。
 *
 * @param index - 社媒图标下标。
 * @returns 指定图标对应的二进制标记位。
 * @throws 当下标不是 0 到 30 之间的整数时抛出异常。
 */
function getFooterPopoverBit(index: number): FooterPopoverVisibleMask {
  if (!Number.isInteger(index) || index < 0 || index > MAX_POPOVER_INDEX) {
    throw new RangeError(`Footer 社媒图标下标无效：${index}`)
  }

  return 1 << index
}

/**
 * 标记指定 Footer 社媒二维码弹窗为可见。
 *
 * @param mask - 当前弹窗可见状态位掩码。
 * @param index - 需要打开的社媒图标下标。
 * @returns 设置指定图标标记位后的可见状态位掩码。
 * @throws 当下标不是 0 到 30 之间的整数时抛出异常。
 */
export function showFooterPopover(mask: FooterPopoverVisibleMask, index: number): FooterPopoverVisibleMask {
  return mask | getFooterPopoverBit(index)
}

/**
 * 标记指定 Footer 社媒二维码弹窗为不可见。
 *
 * @param mask - 当前弹窗可见状态位掩码。
 * @param index - 需要关闭的社媒图标下标。
 * @returns 清除指定图标标记位后的可见状态位掩码。
 * @throws 当下标不是 0 到 30 之间的整数时抛出异常。
 */
export function hideFooterPopover(mask: FooterPopoverVisibleMask, index: number): FooterPopoverVisibleMask {
  return mask & ~getFooterPopoverBit(index)
}

/**
 * 判断指定 Footer 社媒二维码弹窗是否可见。
 *
 * @param mask - 当前弹窗可见状态位掩码。
 * @param index - 需要判断的社媒图标下标。
 * @returns 指定图标的弹窗是否处于可见状态。
 * @throws 当下标不是 0 到 30 之间的整数时抛出异常。
 */
export function isFooterPopoverVisible(mask: FooterPopoverVisibleMask, index: number): boolean {
  return (mask & getFooterPopoverBit(index)) > 0
}
